














import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import bankResource from "@/shared/resource/bank";
import { openUrl } from "@/shared/urlHelper";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";

@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})
export default class PartnerPortalRedirect extends Vue {

  partnerPortalStore = usePartnerPortalStore();

  @Prop()
  portalType: string;

  formId = "redirectSSOForm";

  open (config: any) {
    const url = bankResource.mobileUmbHandoff(config.action, encodeURIComponent(config.value));
    openUrl(url);

    this.$router.go(-1);
  }

  mounted () {
    setTimeout(() => {
      this.partnerPortalStore.getPartnerPortalConfig(this.portalType)
        .then(config => this.open(config));
    }, 1000);
  }

}
